/** @jsxRuntime classic */
/** @jsx React.createElement */
import React from 'react';
import { createRoot } from 'react-dom/client';
import { CssBaseline, ThemeProvider } from "@mui/material";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./mocks/mockApi";
import theme from "./theme/theme";
// if (window.__USE_MOCKS__ ?? true) window.MockApi.enableMocks({ seedCount: 30, seed: 7 });

const container = document.getElementById("elite-core");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
